"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CollapsibleContent = _interopRequireDefault(require("../SpinResults/CollapsibleContent"));
var _gridStyling = require("../styles/gridStyling");
const CollapsibleContentWithPaddingWrapper = ({
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: "p-4"
}, /*#__PURE__*/_react.default.cloneElement(children, props));
const SpinDetail = ({
  index,
  selectedDomain,
  selectedDetailIndex,
  selectedSpinIndex,
  isRightSpinSelected,
  isLeftSpinSelected,
  CelebrateDetailView,
  PremiumDetailView,
  SpinInCartExpandedComponent,
  isSpinExpandable,
  hideDetailedViewExactMatch,
  onExpandedSpinDataNotAvailable,
  cartContents,
  gridNumOfColumns,
  onCardSpinClick
}) => {
  const isDomainInCart = Array.from(cartContents || []).some(cartItem => cartItem.Fqdn === selectedDomain?.Fqdn);
  const onExpandedSpinDataNotAvailableCallback = () => {
    onExpandedSpinDataNotAvailable(index);
    onCardSpinClick(selectedSpinIndex);
  };
  const WrappedPremiumDetailView = props => /*#__PURE__*/_react.default.createElement(CollapsibleContentWithPaddingWrapper, props, /*#__PURE__*/_react.default.createElement(PremiumDetailView, null));
  const WrappedSpinInCartExpandedComponent = props => /*#__PURE__*/_react.default.createElement(CollapsibleContentWithPaddingWrapper, props, /*#__PURE__*/_react.default.createElement(SpinInCartExpandedComponent, null));
  return /*#__PURE__*/_react.default.createElement(_gridStyling.StyledSpinDetail, {
    key: `_${index}`,
    "data-cy": `spin-detail-${index}`,
    columns: gridNumOfColumns,
    isExpanded: index === selectedDetailIndex,
    hideDetailRightCorner: isRightSpinSelected,
    hideDetailLeftCorner: isLeftSpinSelected
  }, /*#__PURE__*/_react.default.createElement(_CollapsibleContent.default, {
    domain: selectedDomain,
    CelebrateDetailView: CelebrateDetailView,
    PremiumDetailView: WrappedPremiumDetailView,
    SpinInCartExpandedComponent: WrappedSpinInCartExpandedComponent,
    isDomainInCart: isDomainInCart,
    isSpinExpandable: isSpinExpandable,
    hideDetailedViewExactMatch: hideDetailedViewExactMatch,
    onExpandedSpinDataNotAvailable: onExpandedSpinDataNotAvailableCallback
  }));
};
var _default = exports.default = SpinDetail;